import { useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const MONTHS = ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"];
const pad = (n) => String(n).padStart(2, "0");
const lastDay = (y, m) => new Date(y, m, 0).getDate();

function range(year, part) {
  if (part === "all") return [`${year}-01-01`, `${year}-12-31`];
  if (part.startsWith("q")) {
    const q = Number(part[1]);
    const end = q * 3;
    return [`${year}-${pad(end - 2)}-01`, `${year}-${pad(end)}-${lastDay(year, end)}`];
  }
  const m = Number(part);
  return [`${year}-${pad(m)}-01`, `${year}-${pad(m)}-${lastDay(year, m)}`];
}

export default function PeriodSelect({ years, onRange, testid = "period", allowAll = true }) {
  const [year, setYear] = useState("");
  const [part, setPart] = useState("all");

  const apply = (y, p) => {
    setYear(y); setPart(y ? p : "all");
    if (!y) { onRange("", ""); return; }
    const [a, b] = range(Number(y), p);
    onRange(a, b);
  };

  return (
    <div className="flex gap-2" data-testid={testid}>
      <Select value={year || "__none__"} onValueChange={(v) => apply(v === "__none__" ? "" : v, part)}>
        <SelectTrigger className="w-[150px]" data-testid={`${testid}-year`}><SelectValue placeholder="Yıl" /></SelectTrigger>
        <SelectContent>
          <SelectItem value="__none__">{allowAll ? "Tüm dönemler" : "Yıl seçin"}</SelectItem>
          {years.map(y => <SelectItem key={y} value={String(y)}>{y}</SelectItem>)}
        </SelectContent>
      </Select>
      <Select value={part} onValueChange={(v) => apply(year, v)} disabled={!year}>
        <SelectTrigger className="w-[150px]" data-testid={`${testid}-part`}><SelectValue /></SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Tüm yıl</SelectItem>
          {[1, 2, 3, 4].map(q => <SelectItem key={q} value={`q${q}`}>{q}. Çeyrek</SelectItem>)}
          {MONTHS.map((m, i) => <SelectItem key={m} value={String(i + 1)}>{m}</SelectItem>)}
        </SelectContent>
      </Select>
    </div>
  );
}
